<template>
  <div id="app">
    <!-- 头部 -->
    <HeaderTopView v-bind:num="num" @childFn="parentFn($event)"></HeaderTopView>
    <HeaderView></HeaderView>
    <NavView></NavView>
    <section class="banner_div word">
      <div class="content">
        <h3 class="title">{{data.title}}</h3>
        <div class="title1">
          <div class="t-l">
            <span>{{data.createTime}}</span>
          </div>
        </div>
        <article v-html="data.content">
          {{data.content}}
        </article>

      </div>
    </section>

    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import HeaderTopView from '@/components/assembly/HeaderTop.vue';//头部模块
  import HeaderView from '@/components/assembly/Header.vue';//头部模块
  import NavView from '@/components/assembly/Nav.vue';//导航模块
  import Footer from '@/components/assembly/Footer.vue';//导航模块
    export default {
        name: "NewsDetail",
      data() {
        return {
          num:'1',
          data:{}
        }
      },
        components: {
        HeaderView, NavView, HeaderTopView,Footer
      },
      created(){
        this.getMsg()
      },
      methods:{
        getMsg(){
          let nid = this.$route.query.nid ? this.$route.query.nid : 0;
          let url = `/open/news/information/news/detail/${nid}`
          this.$get(url).then( res => {
            this.data = res.data
          })
        }
      }
    }

</script>

<style scoped>
.content{
  padding: 76px 0 110px 0;
}
  .title{
    font-size: 26px;
    color: #1A1A1A;
    font-weight: bold;
    margin-bottom: 25px;
    text-align: left;
  }
  .title1{
    display: flex;
    justify-content: space-between;
    color: #666666;
    font-size: 16px;
    padding-bottom: 45px;
    border-bottom: 1px dashed #02082C;
  }
  .come{
    padding-right: 23px;
    border-right: 1px solid #666;
    margin-right: 10px;
    margin-bottom: 43px;
  }
article{
  font-size: 16px;
  color: #4A4A4A;
  text-align: left;
  margin-top: 43px;
}
  .img{
    margin: 38px 0 44px 0;
    width: 100%;
    height: 477px;
  }
  img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .article-e{
    padding-bottom: 60px;
    border-bottom: 1px dashed #02082C;
    margin-bottom: 56px;
  }
  .n-title{
    color: #545454;
    font-size: 16px;
  }
.n-title:last-child{
  margin-top: 30px;
}
  .paragraph{
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/newsDetail/NewsDetail.vue